import { ChangeDetectionStrategy, Component, Input, TemplateRef } from '@angular/core';
import { CdkOverlayOrigin } from '@angular/cdk/overlay';

import { SdCoreTooltipComponent } from '../core-tooltip/core-tooltip.component';
import { PositionEnum } from '../../../_enums/position.enum';
import { SdThemeComponent } from '../../abstract/theme/theme.component';
import { SdThemeWrapperComponent } from '../../theme-wrapper/theme-wrapper.component';

@Component({
  selector: 'sd-tooltip, [sd-tooltip]',
  templateUrl: './tooltip.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CdkOverlayOrigin,
    SdThemeWrapperComponent,
    SdCoreTooltipComponent
  ]
})
export class SdTooltipComponent extends SdThemeComponent {
  @Input()
  tooltipTemplate: TemplateRef<any>;

  @Input()
  position:
    | PositionEnum.left
    | PositionEnum.top
    | PositionEnum.right
    | PositionEnum.bottom;

  @Input()
  tooltipClass = '';

  @Input()
  tooltipContentDisplayStyle = 'inline-flex';
}
